import React, { useEffect, useRef, useState } from "react";
import { ToastContainer } from "react-toastify";
import DocsUpload from "./DocsUpload";
import IncomeDetails from "./IncomeDetails";
import KycDetails from "./KycDetails";
import ProfileDetails from "./ProfileDetails";

const ProfileSteps = (props) => {
  const verifyBtnRef = useRef(0);
  const toastConfig = {
    autoClose: 3000,
    closeButton: false,
    hideProgressBar: true,
  };
  const {
    customerId,
    aadharCardInfo,
    panCardInfo,
    addresses,
    officialEmail,
    panFileId,
    aadharFrontFileId,
    aadharBackFileId,
    emailVerification,
  } = props?.editdata;

  const hasEditData = officialEmail?.length > 0 ? true : false;

  const isIncomeDetailsVerified =
    props?.$store?.user?.officialEmail?.length > 0
      ? true
      : officialEmail?.length > 0
        ? true
        : false;

  const kycDetailsVerified =
    props?.$store?.user?.aadharCardInfo &&
      Object.keys(props?.$store?.user?.aadharCardInfo)?.length > 0 &&
      props?.$store?.user?.panCardInfo &&
      Object.keys(props?.$store?.user?.panCardInfo)?.length > 0 &&
      props?.$store?.user?.addresses &&
      Object.keys(props?.$store?.user?.addresses)?.length > 0
      ? true
      : aadharCardInfo &&
        Object.keys(aadharCardInfo).length > 0 &&
        panCardInfo &&
        Object.keys(panCardInfo).length > 0 &&
        addresses &&
        Object.keys(addresses).length > 0
        ? true
        : false;

  // const isDocsVerified =
  //   panFileId &&
  //   Object.keys(panFileId).length > 0 &&
  //   aadharFrontFileId &&
  //   Object.keys(aadharFrontFileId).length > 0 &&
  //   aadharBackFileId &&
  //   Object.keys(aadharBackFileId).length > 0
  //     ? true
  //     : false;
  const isDocsVerified =
    panFileId && Object.keys(panFileId).length > 0 ? true : false;

  // ----------------------------------------------------------------
  const handlePreview = () => {
    props.handleSubmit();
  };

  const handleDocsSubmit = (data) => {
    let payload = {
      ...Object.except(data, ["fileName"]),
    };

    props.apis.apiUploadCustomerDocs(payload).then((res) => {
      console.log({ apiUploadCustomerDocs: res });
      props.handleSubmit();
    });
  };

  // PROFILE DETAILS
  const onProfileSubmit = (e, data) => {
    if (emailVerification === false) {
      swal2.fire({
        title: "Email verification needed",
        icon: "error",
        iconColor: "#BB1766",
        confirmButtonColor: "#BB1766",
        confirmButtonText: "Ok",
      });
      return;
    }

    let payload = {
      ...Object.except(data, ["mobileNumber"]),
      pincode: Number(data?.pincode),
      dob: new Date(data?.dob).toISOString(),
    };

    const resolve = () => {
      props.store("user", {
        ...props?.$store?.user,
        customerName: payload?.customerName,
        emailAddress: payload?.emailAddress,
        gender: payload?.gender,
        dob: payload?.dob,
        maritalStatus: payload?.maritalStatus,
        religion: payload?.religion,
        emailVerification: emailVerification,
        pincode: payload?.pincode,
      });
    };

    console.log({ payload });

    props.apis.apiUpdateCustomerDetails(payload).then((res) => {
      console.log({ res });
      resolve();
      toast.success("Profile Details Updated Successfully", toastConfig);
      skipToStep(2);
    });

    // ----- MOKE FLOW

    // const resolve = () => {
    //   props.store("user", {
    //     ...props?.$store?.user,
    //     customerName: "test user",
    //     emailAddress: "test@test.com",
    //     gender: "Male",
    //     dob: new Date().toISOString(),
    //     maritalStatus: "SINGLE",
    //     religion: "CHRISTIAN",
    //     emailVerification: true,
    //     pincode: "638004",
    //   });
    // };
    // resolve();
    // toast.success("Profile Details Updated Successfully", toastConfig);
    // skipToStep(2);
  };

  // INCOME DETAILS
  const onIncomeSubmit = (e, data) => {
    console.log("Income Details: ", data);

    let payload = {
      ...Object.except(data, ["employmentType", "newcompanyname"]),
    };

    if (data?.employmentType !== "SALARIED") {
      payload.isSalaried = false;
      swal2.fire({
        title: "We are Sorry! ",
        text: "Currently we are catering to the salaried person only. Thank you for your interest we will get back to you",
        icon: "warning",
        iconColor: "#BB1766",
        confirmButtonColor: "#BB1766",
        confirmButtonText: "Ok",
      });
      return;
    } else {
      payload.isSalaried = true;
    }

    if (data?.companyname === "OTHERS") {
      payload.companyname = data.newcompanyname;
    } else {
      payload.companyname = data.companyname;
    }
    console.log({ payload });

    const resolve = () => {
      props.store("user", {
        ...props?.$store?.user,
        officialEmail: payload?.officialEmail,
        monthlySalary: payload?.monthlySalary,
        salaryMode: payload?.salaryMode,
        companyname: payload?.companyname,
      });
    };

    if (hasEditData) {
      props.apis.apiUpdateCustomerIncomeDetails(payload).then((res) => {
        console.log({ res });
        resolve();
        toast.success("Income Details Updated Successfully", toastConfig);
        skipToStep(2);
      });
    } else {
      props.apis.apiSaveCustomerIncomeDetails(payload).then((res) => {
        console.log({ res });
        resolve();
        toast.success("Income Details Submitted Successfully", toastConfig);
        skipToStep(2);
      });
    }
  };

  // ----------------------------------------------------------------
  const skipToStep = (step) => {
    props.setGoSteps(step);
  };
  return (
    <>
      <ToastContainer />
      <div className="form-wizard profile_stepper_container">
        <div style={{
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          width: '100%',
          padding: '30px',
          maxWidth: '600px',
          margin: '0px auto 40px',
          border: '1px solid #E0C7D9',
          backgroundColor: '#FEF2F8',
          borderRadius: '14px',
        }}>
          {[
            {
              label: "Personal\nDetails",
              icon: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z" />
                </svg>
              ),
              stepIndex: 0,
              completed: emailVerification,
            },
            {
              label: "KYC\nDetails",
              icon: (
                <img src={imagepaths.kycIconImg} alt="kycIconImg" width={24} height={24} />
              ),
              stepIndex: 2,
              completed: kycDetailsVerified,
            },
            {
              label: "Document\nUpload",
              icon: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M21 4H3C1.89 4 1.01 4.89 1.01 6L1 18C1 19.11 1.89 20 3 20H21C22.11 20 23 19.11 23 18V6C23 4.89 22.11 4 21 4ZM21 18H3V12H21V18ZM21 8H3V6H21V8Z" />
                </svg>
              ),
              stepIndex: 3,
              completed: isDocsVerified,
            }
          ].map((step, index, arr) => {
            const isActiveOrCompleted = props.goSteps >= step.stepIndex || step.completed;

            return (
              <React.Fragment key={index}>
                <div
                  style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer', width: '100px' }}
                  onClick={() => props.setGoSteps(step.stepIndex)}
                >
                  <div style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    border: `3px solid ${isActiveOrCompleted ? '#BB1766' : '#b7b7b7'}`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#fff',
                    color: isActiveOrCompleted ? '#BB1766' : '#b7b7b7',
                    marginBottom: '10px',
                    transition: 'all 0.3s ease'
                  }}>
                    {step.icon}
                  </div>
                  <div style={{
                    color: isActiveOrCompleted ? '#BB1766' : '#b7b7b7',
                    fontWeight: '600',
                    fontSize: '15px',
                    textAlign: 'center',
                    lineHeight: '1.4',
                    transition: 'all 0.3s ease'
                  }}>
                    {step.label.split('\n').map((line, i) => (
                      <div key={i}>{line}</div>
                    ))}
                  </div>
                </div>
                {index < arr.length - 1 && (
                  <div style={{
                    flexGrow: 1,
                    height: '0',
                    borderTop: '5px dotted #c4c4c4',
                    marginTop: '28px',
                    marginLeft: '15px',
                    marginRight: '15px'
                  }}></div>
                )}
              </React.Fragment>
            );
          })}
        </div>
        {props.goSteps === 0 && (
          <ProfileDetails
            skipToStep={(...args) => skipToStep(...args)}
            onProfileSubmit={(...args) => onProfileSubmit(...args)}
            onCustomerVerifyEmail={(...args) => customerVerifyEmail(...args)}
            onClose={props.onClose}
            editdata={props.editdata}
            refetchProfile={props.refetchProfile}
          />
        )}
        {props.goSteps === 1 && (
          <IncomeDetails
            skipToStep={(...args) => skipToStep(...args)}
            onIncomeSubmit={(...args) => onIncomeSubmit(...args)}
            onClose={props.onClose}
            editdata={props.editdata}
          />
        )}
        {props.goSteps === 2 && (
          <KycDetails
            editdata={props.editdata}
            skipToStep={(...args) => skipToStep(...args)}
            onClose={props.onClose}
          />
        )}
        {props.goSteps === 3 && (
          <DocsUpload
            skipToStep={(...args) => skipToStep(...args)}
            handleDocsSubmit={(...args) => handleDocsSubmit(...args)}
            handlePreview={(...args) => handlePreview(...args)}
            editdata={props.editdata}
            onClose={props.onClose}
          />
        )}
      </div>
    </>
  );
};

export default constore(ProfileSteps);
